var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevelPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Level_2434834") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions/New",
    transform: "translate(-868.000000, -2175.000000)",
    fill: "#274784",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(51.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(39.000000, 1974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(399.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Level_2434834",
    transform: "translate(39.000000, 64.218750)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.781250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.934375,3.71555556 L5.29479167,3.71555556 C5.63020833,4.81555556 6.63645833,5.62222222 7.834375,5.62222222 C9.03229167,5.62222222 10.0385417,4.81555556 10.3739583,3.71555556 L22.065625,3.71555556 C22.5208333,3.71555556 22.8802083,3.34888889 22.8802083,2.88444444 C22.8802083,2.42 22.5208333,2.05333333 22.065625,2.05333333 L10.3979167,2.05333333 C10.0385417,0.977777778 9.03229167,0.146666667 7.834375,0.146666667 C6.63645833,0.146666667 5.63020833,0.977777778 5.29479167,2.07777778 L0.934375,2.07777778 C0.479166667,2.07777778 0.119791667,2.44444444 0.119791667,2.90888889 C0.119791667,3.37333333 0.479166667,3.71555556 0.934375,3.71555556 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.065625,10.1688889 L17.7052083,10.1688889 C17.3697917,9.06888889 16.3635417,8.26222222 15.165625,8.26222222 C13.9677083,8.26222222 12.9614583,9.06888889 12.6260417,10.1688889 L0.934375,10.1688889 C0.479166667,10.1688889 0.119791667,10.5355556 0.119791667,11 C0.119791667,11.4644444 0.479166667,11.8311111 0.934375,11.8311111 L12.6260417,11.8311111 C12.9614583,12.9311111 13.9677083,13.7377778 15.165625,13.7377778 C16.3635417,13.7377778 17.3697917,12.9311111 17.7052083,11.8311111 L22.065625,11.8311111 C22.5208333,11.8311111 22.8802083,11.4644444 22.8802083,11 C22.8802083,10.5355556 22.5208333,10.1688889 22.065625,10.1688889 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.065625,18.2844444 L10.3979167,18.2844444 C10.0625,17.1844444 9.05625,16.3777778 7.85833333,16.3777778 C6.66041667,16.3777778 5.65416667,17.1844444 5.31875,18.2844444 L0.934375,18.2844444 C0.479166667,18.2844444 0.119791667,18.6511111 0.119791667,19.1155556 C0.119791667,19.58 0.479166667,19.9466667 0.934375,19.9466667 L5.29479167,19.9466667 C5.63020833,21.0466667 6.63645833,21.8533333 7.834375,21.8533333 C9.03229167,21.8533333 10.0385417,21.0466667 10.3739583,19.9466667 L22.065625,19.9466667 C22.5208333,19.9466667 22.8802083,19.58 22.8802083,19.1155556 C22.8802083,18.6511111 22.5208333,18.2844444 22.065625,18.2844444 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelPoints);
export default __webpack_public_path__ + "static/media/level-points.5738ee180fe462823d343c601ae16afd.svg";
export { ForwardRef as ReactComponent };